import { LockClosedIcon } from '@radix-ui/react-icons';
import { AccessibleIcon, Box, Flex, Grid, mdxComponents, ProviderIcon, Text } from '@workos-inc/design-system';
import * as React from 'react';
import { Diagram } from './diagram';

// Introducing lint rule banning type assertions
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const MdxImage = mdxComponents.Image as React.FC<React.PropsWithChildren>;
const AuthenticationMethods = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="AuthenticationMethods" data-sentry-source-file="authkit-diagrams.tsx">
    <AccessibleIcon label="A diagram showing two users. User A has an email address that’s associated both with his password sign-in method and a Google profile. User B has an email address that’s associated with a Microsoft and a Google profile, and no password sign-in." data-sentry-element="AccessibleIcon" data-sentry-source-file="authkit-diagrams.tsx">
      <svg viewBox="0 0 688 288" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="authkit-diagrams.tsx">
        <foreignObject height="288" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="authkit-diagrams.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="authkit-diagrams.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
              <Diagram.Panel height={224} width={304} data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="authkit-diagrams.tsx">User A</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                  <Text style={
                // Introducing lint rule banning type assertions
                // Type assertion seems to be here to workaround --line-height being unknown property
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                  'fontSize': 13,
                  '--line-height': 16 / 13
                } as React.CSSProperties} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                    <Flex direction="column" gap="4" p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                      <Flex p="4" style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                        <Text color="gray" style={{
                        width: 80
                      }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                          Email
                        </Text>
                        <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">john.doe@example.com</Text>
                      </Flex>

                      <Box style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Password
                          </Text>
                          <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">•••••••••••</Text>
                        </Flex>
                        <Box style={{
                        marginTop: -1,
                        borderTop: '1px dashed var(--gray-a6)'
                      }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Profile
                          </Text>
                          <Flex align="center" style={{
                          gap: '0.5em'
                        }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <ProviderIcon my="-1" provider="google" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Google</Text>
                          </Flex>
                        </Flex>
                      </Box>
                    </Flex>
                  </Text>
                </Diagram.PanelContent>
              </Diagram.Panel>

              <Diagram.Panel height={224} width={304} data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="authkit-diagrams.tsx">User B</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                  <Text style={
                // Introducing lint rule banning type assertions
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                  'fontSize': 13,
                  '--line-height': 16 / 13
                } as React.CSSProperties} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                    <Flex direction="column" gap="4" p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                      <Flex p="4" style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                        <Text color="gray" style={{
                        width: 80
                      }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                          Email
                        </Text>
                        <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">jane.roe@example.com</Text>
                      </Flex>

                      <Box style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Profile
                          </Text>
                          <Flex align="center" style={{
                          gap: '0.5em'
                        }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <ProviderIcon my="-1" provider="microsoft" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Microsoft</Text>
                          </Flex>
                        </Flex>
                        <Box style={{
                        marginTop: -1,
                        borderTop: '1px dashed var(--gray-a6)'
                      }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Profile
                          </Text>
                          <Flex align="center" style={{
                          gap: '0.5em'
                        }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <ProviderIcon my="-1" provider="google" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Google</Text>
                          </Flex>
                        </Flex>
                      </Box>
                    </Flex>
                  </Text>
                </Diagram.PanelContent>
              </Diagram.Panel>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const EnterpriseUsers = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="EnterpriseUsers" data-sentry-source-file="authkit-diagrams.tsx">
    <AccessibleIcon label="A diagram showing two enterprises. Enterprise A uses Okta as an identity provider for their users. Enterprise B uses Google Workspace as an identity provider for their users. In both cases, user’s data like their email addresses and names are controlled by the identity provider and the enterprise using it." data-sentry-element="AccessibleIcon" data-sentry-source-file="authkit-diagrams.tsx">
      <svg viewBox="0 0 688 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="authkit-diagrams.tsx">
        <foreignObject height="320" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="authkit-diagrams.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="authkit-diagrams.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
              {([{
              title: 'Enterprise A',
              provider: 'Okta',
              providerIcon: 'okta',
              email: 'john@foo-corp.com',
              name: 'John Doe'
            }, {
              title: 'Enterprise B',
              provider: 'Google Workspace',
              providerIcon: 'google',
              email: 'jane@baz-corp.com',
              name: 'Jane Roe'
            }] as const).map(item => <Diagram.Panel key={item.title} height={256} width={304}>
                  <Diagram.PanelHeader>{item.title}</Diagram.PanelHeader>
                  <Diagram.PanelContent>
                    <Text style={
                // Introducing lint rule banning type assertions
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                  'fontSize': 13,
                  '--line-height': 16 / 13
                } as React.CSSProperties}>
                      <Flex direction="column" gap="2" p="4">
                        <Flex p="4" style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }}>
                          <Text color="gray" style={{
                        width: 80
                      }}>
                            Provider
                          </Text>
                          <Flex align="center" style={{
                        gap: '0.5em'
                      }}>
                            <ProviderIcon my="-1" provider={item.providerIcon} size="1" />
                            <Text>{item.provider}</Text>
                          </Flex>
                        </Flex>

                        <Flex justify="center">
                          <Flex height="32px" justify="between" style={{
                        width: 88,
                        marginTop: -2,
                        marginBottom: 2
                      }}>
                            <Diagram.Arrow direction="down" />
                            <Diagram.Arrow direction="down" />
                            <Diagram.Arrow direction="down" />
                          </Flex>
                        </Flex>

                        <Flex direction="column">
                          <Box style={{
                        marginLeft: -4,
                        marginRight: 4,
                        marginTop: -5,
                        backgroundColor: 'var(--color-panel-solid)',
                        border: '1px dashed var(--gray-a6)',
                        borderRadius: 'var(--radius-3)'
                      }}>
                            <Box height="48px" />
                            <Box style={{
                          marginTop: -1,
                          borderTop: '1px dashed var(--gray-a6)'
                        }} />
                            <Box height="48px" />
                          </Box>

                          <Box style={{
                        marginTop: -94,
                        backgroundColor: 'var(--color-panel-solid)',
                        border: '1px dashed var(--gray-a6)',
                        borderRadius: 'var(--radius-3)'
                      }}>
                            <Box height="48px" />
                            <Box style={{
                          marginTop: -1,
                          borderTop: '1px dashed var(--gray-a6)'
                        }} />
                            <Box height="48px" />
                          </Box>

                          <Box style={{
                        marginTop: -94,
                        marginLeft: 4,
                        marginRight: -4,
                        backgroundColor: 'var(--color-panel-solid)',
                        border: '1px dashed var(--gray-a6)',
                        borderRadius: 'var(--radius-3)'
                      }}>
                            <Flex p="4">
                              <Text color="gray" style={{
                            width: 80
                          }}>
                                Name
                              </Text>
                              <Flex align="center" ml="-1" style={{
                            gap: '0.5em'
                          }}>
                                <LockClosedIcon color="var(--gray-a11)" />
                                <Text>{item.name}</Text>
                              </Flex>
                            </Flex>
                            <Box style={{
                          marginTop: -1,
                          borderTop: '1px dashed var(--gray-a6)'
                        }} />
                            <Flex p="4">
                              <Text color="gray" style={{
                            width: 80
                          }}>
                                Email
                              </Text>
                              <Flex align="center" ml="-1" style={{
                            gap: '0.5em'
                          }}>
                                <LockClosedIcon color="var(--gray-a11)" />
                                <Text>{item.email}</Text>
                              </Flex>
                            </Flex>
                          </Box>
                        </Flex>
                      </Flex>
                    </Text>
                  </Diagram.PanelContent>
                </Diagram.Panel>)}
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const IdentityLinking = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="IdentityLinking" data-sentry-source-file="authkit-diagrams.tsx">
    <AccessibleIcon label="A diagram showing two Google OAuth and Microsoft OAuth credentials, both for jane.roe@example.com email address. Since both social profiles are tied to the same email address, WorkOS links them together to the same user." data-sentry-element="AccessibleIcon" data-sentry-source-file="authkit-diagrams.tsx">
      <svg viewBox="0 0 688 336" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="authkit-diagrams.tsx">
        <foreignObject height="336" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="authkit-diagrams.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="authkit-diagrams.tsx">
            <Grid align="center" columns="304px 32px 288px" data-sentry-element="Grid" data-sentry-source-file="authkit-diagrams.tsx">
              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.Panel height={128} width="100%" data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                    <Text style={
                  // Introducing lint rule banning type assertions
                  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                  {
                    'fontSize': 13,
                    '--line-height': 16 / 13
                  } as React.CSSProperties} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                      <Box p="4" data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                        <Box style={{
                        marginTop: -1,
                        marginBottom: -1,
                        border: '1px dashed var(--gray-a6)',
                        borderRadius: 'var(--radius-3)'
                      }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                          <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <Text color="gray" style={{
                            width: 80
                          }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                              Email
                            </Text>
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">jane.roe@example.com</Text>
                          </Flex>
                          <Box style={{
                          marginTop: -1,
                          borderTop: '1px dashed var(--gray-a6)'
                        }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                          <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <Text color="gray" style={{
                            width: 80
                          }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                              Credential
                            </Text>
                            <Flex align="center" style={{
                            gap: '0.5em',
                            marginLeft: -3
                          }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                              <ProviderIcon my="-1" provider="google" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                              <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Google OAuth</Text>
                            </Flex>
                          </Flex>
                        </Box>
                      </Box>
                    </Text>
                  </Diagram.PanelContent>
                </Diagram.Panel>

                <Diagram.Panel height={128} width="100%" data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                    <Text style={
                  // Introducing lint rule banning type assertions
                  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                  {
                    'fontSize': 13,
                    '--line-height': 16 / 13
                  } as React.CSSProperties} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                      <Box p="4" data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                        <Box style={{
                        marginTop: -1,
                        marginBottom: -1,
                        border: '1px dashed var(--gray-a6)',
                        borderRadius: 'var(--radius-3)'
                      }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                          <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <Text color="gray" style={{
                            width: 80
                          }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                              Email
                            </Text>
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">jane.roe@example.com</Text>
                          </Flex>
                          <Box style={{
                          marginTop: -1,
                          borderTop: '1px dashed var(--gray-a6)'
                        }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                          <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <Text color="gray" style={{
                            width: 80
                          }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                              Credential
                            </Text>
                            <Flex align="center" style={{
                            gap: '0.5em',
                            marginLeft: -3
                          }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                              <ProviderIcon my="-1" provider="microsoft" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                              <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Microsoft OAuth</Text>
                            </Flex>
                          </Flex>
                        </Box>
                      </Box>
                    </Text>
                  </Diagram.PanelContent>
                </Diagram.Panel>
              </Flex>

              <Grid align="center" columns="16px 16px" rows="144px" data-sentry-element="Grid" data-sentry-source-file="authkit-diagrams.tsx">
                <Flex direction="column" height="100%" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                  <Box style={{
                  height: '50%',
                  borderTopRightRadius: 'var(--radius-5)',
                  borderTop: '1px solid var(--gray-7)',
                  borderRight: '1px solid var(--gray-7)',
                  marginRight: -0.5
                }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                  <Box style={{
                  height: '50%',
                  borderBottomRightRadius: 'var(--radius-5)',
                  borderBottom: '1px solid var(--gray-7)',
                  borderRight: '1px solid var(--gray-7)',
                  marginRight: -0.5
                }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                </Flex>
                <Flex align="center" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                  <Box style={{
                  width: 7,
                  height: 7,
                  marginLeft: -3,
                  borderRadius: '100%',
                  border: '1px solid var(--gray-8)',
                  backgroundColor: 'var(--color-background)'
                }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                  <Box flexGrow="1" style={{
                  borderTop: '1px solid var(--gray-7)'
                }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                </Flex>
              </Grid>

              <Diagram.Panel height={224} width="auto" data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="authkit-diagrams.tsx">User</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                  <Text style={
                // Introducing lint rule banning type assertions
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                  'fontSize': 13,
                  '--line-height': 16 / 13
                } as React.CSSProperties} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                    <Flex direction="column" gap="4" p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                      <Flex p="4" style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                        <Text color="gray" style={{
                        width: 80
                      }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                          Email
                        </Text>
                        <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">jane.roe@example.com</Text>
                      </Flex>

                      <Box style={{
                      marginTop: -1,
                      marginBottom: -1,
                      border: '1px dashed var(--gray-a6)',
                      borderRadius: 'var(--radius-3)'
                    }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Profile
                          </Text>
                          <Flex align="center" style={{
                          gap: '0.5em',
                          marginLeft: -3
                        }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <ProviderIcon my="-1" provider="microsoft" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Microsoft</Text>
                          </Flex>
                        </Flex>
                        <Box style={{
                        marginTop: -1,
                        borderTop: '1px dashed var(--gray-a6)'
                      }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx" />
                        <Flex p="4" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                          <Text color="gray" style={{
                          width: 80
                        }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                            Profile
                          </Text>
                          <Flex align="center" style={{
                          gap: '0.5em',
                          marginLeft: -3
                        }} data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                            <ProviderIcon my="-1" provider="google" size="1" data-sentry-element="ProviderIcon" data-sentry-source-file="authkit-diagrams.tsx" />
                            <Text data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">Google</Text>
                          </Flex>
                        </Flex>
                      </Box>
                    </Flex>
                  </Text>
                </Diagram.PanelContent>
              </Diagram.Panel>
            </Grid>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const UserToOrganizationRelationships = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="UserToOrganizationRelationships" data-sentry-source-file="authkit-diagrams.tsx">
    <AccessibleIcon label="A diagram showing two apps that have different relationships between users and organizations. App A has a many-to-many relationship between its users and organization. App B allows each user to be a member only of one organization." data-sentry-element="AccessibleIcon" data-sentry-source-file="authkit-diagrams.tsx">
      <svg viewBox="0 0 688 288" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="authkit-diagrams.tsx">
        <foreignObject height="288" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="authkit-diagrams.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="authkit-diagrams.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
              <Diagram.Panel height={224} width={304} data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="authkit-diagrams.tsx">Multiple Workspaces</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                  <Flex align="stretch" m="2" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                    <Box pt="2" px="2" style={{
                    width: 132,
                    borderRadius: 'var(--radius-4)',
                    backgroundColor: 'var(--blue-a3)'
                  }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                      <Grid columns="6" style={{
                      rowGap: 5,
                      columnGap: 4,
                      color: 'var(--blue-9)'
                    }} data-sentry-element="Grid" data-sentry-source-file="authkit-diagrams.tsx">
                        {Array(6 * 7).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
                      </Grid>
                      <Text align="center" as="div" style={{
                      color: 'var(--blue-a10)',
                      fontSize: 11,
                      lineHeight: 24 / 11
                    }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                        Users
                      </Text>
                    </Box>

                    <svg fill="none" height="176" stroke="var(--gray-7)" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 64 176" width="64" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="authkit-diagrams.tsx">
                      <path d="M-0.25 36.6177C12.3477 30.1178 25.4184 13.6177 64.25 16.1177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 36.6175C34.6327 35.6174 10.9388 104.618 64.25 100.617" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 36.6175C34.6327 35.6175 34.5195 61.1179 64.25 59.1179" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 15.6178C-0.25 15.6178 33.0078 5.1178 64.25 37.6178" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M0 15.5C16.6289 32 40.5664 35.1177 64.25 58.1177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 57.6177C-0.25 57.6177 24.102 81.6177 64.25 78.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 78.6177C32 78.6177 64.25 99.6177 64.25 99.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 100.618C32 100.618 24.102 102.618 64.25 99.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 78.6177C32 78.6177 24.102 124.618 64.25 121.618" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 78.6177C32 78.6177 22.4258 34.6177 64.25 15.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 100.618C15.875 85.6177 24.102 81.6177 64.25 78.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 100.618C32 100.618 36.5352 46.1177 64.25 37.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M0 100.5C20.6602 109.5 24.102 124.618 64.25 121.618" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M0 100.5C0 100.5 24.102 145.618 64.25 142.618" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 121.618C14.8672 107.618 52.1562 86.6177 64.25 58.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 121.618C10.8359 129.118 24.102 145.618 64.25 142.618" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 142.618C32 142.618 44.5977 59.6177 64.25 37.6177" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 121.618C32 121.618 43.0859 111.118 64.25 100.618" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 142.618C32 142.618 24.102 124.118 64.25 121.118" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                      <path d="M-0.25 142.618C32 142.618 64.25 121.118 64.25 121.118" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
                    </svg>

                    <Box pt="2" px="2" style={{
                    width: 92,
                    borderRadius: 'var(--radius-4)',
                    backgroundColor: 'var(--green-a3)'
                  }} data-sentry-element="Box" data-sentry-source-file="authkit-diagrams.tsx">
                      <Grid columns="4" style={{
                      rowGap: 5,
                      columnGap: 4,
                      color: 'var(--green-9)'
                    }} data-sentry-element="Grid" data-sentry-source-file="authkit-diagrams.tsx">
                        {Array(4 * 7).fill(0).map((_, i) => <OrganizationIcon key={i} fillOpacity="0.8" />)}
                      </Grid>
                      <Text align="center" as="div" style={{
                      color: 'var(--green-a10)',
                      fontSize: 11,
                      lineHeight: 24 / 11
                    }} data-sentry-element="Text" data-sentry-source-file="authkit-diagrams.tsx">
                        Organizations
                      </Text>
                    </Box>
                  </Flex>
                </Diagram.PanelContent>
              </Diagram.Panel>

              <Diagram.Panel height={224} width={304} data-sentry-element="Diagram.Panel" data-sentry-source-file="authkit-diagrams.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="authkit-diagrams.tsx">Single Workspace</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="authkit-diagrams.tsx">
                  <Flex gap="2" m="2" data-sentry-element="Flex" data-sentry-source-file="authkit-diagrams.tsx">
                    {[{
                    backgroundColor: 'var(--blue-a3)',
                    textColor: 'var(--blue-a10)',
                    textOpacity: '1',
                    iconColor: 'var(--blue-9)',
                    iconOpacity: '0.8'
                  }, {
                    backgroundColor: 'var(--yellow-a3)',
                    textColor: 'var(--yellow-a11)',
                    textOpacity: '0.85',
                    iconColor: 'var(--yellow-11)',
                    iconOpacity: '0.6'
                  }, {
                    backgroundColor: 'var(--green-a3)',
                    textColor: 'var(--green-a10)',
                    textOpacity: '1',
                    iconColor: 'var(--green-9)',
                    iconOpacity: '0.8'
                  }].map((item, i) => <Box key={item.backgroundColor} pt="2" px="2" style={{
                    width: 92,
                    borderRadius: 'var(--radius-4)',
                    backgroundColor: item.backgroundColor
                  }}>
                        <Flex align="center" justify="center">
                          <OrganizationIcon color={item.iconColor} fillOpacity={item.iconOpacity} />
                        </Flex>
                        <Text align="center" as="div" mx="-1" style={{
                      color: item.textColor,
                      opacity: item.textOpacity,
                      fontSize: 11,
                      lineHeight: 24 / 11,
                      marginBottom: 2
                    }}>
                          Organization {i + 1}
                        </Text>

                        <Grid columns="4" style={{
                      rowGap: 5,
                      columnGap: 4
                    }}>
                          {Array(4 * 5).fill(0).map((_, i) => <UserCircledIcon key={i} color={item.iconColor} fillOpacity={item.iconOpacity} />)}
                        </Grid>
                        <Text align="center" as="div" style={{
                      color: item.textColor,
                      opacity: item.textOpacity,
                      fontSize: 11,
                      lineHeight: 24 / 11,
                      marginBottom: 2
                    }}>
                          Users
                        </Text>
                      </Box>)}
                  </Flex>
                </Diagram.PanelContent>
              </Diagram.Panel>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const UserCircledIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => <svg fill="currentcolor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="UserCircledIcon" data-sentry-source-file="authkit-diagrams.tsx">
    <path d="M8 1.5C4.41797 1.5 1.5 4.41797 1.5 8C1.5 11.582 4.41797 14.5 8 14.5C11.582 14.5 14.5 11.582 14.5 8C14.5 4.41797 11.582 1.5 8 1.5ZM8 2.5C11.043 2.5 13.5 4.95703 13.5 8C13.5 9.33984 13.0234 10.5625 12.2344 11.5156C11.8047 10.2969 10.875 9.31641 9.6875 8.83203C10.1836 8.375 10.5 7.72266 10.5 7C10.5 5.625 9.375 4.5 8 4.5C6.625 4.5 5.5 5.625 5.5 7C5.5 7.72266 5.81641 8.375 6.3125 8.83203C5.125 9.31641 4.19922 10.2969 3.76953 11.5156C2.97656 10.5625 2.5 9.33984 2.5 8C2.5 4.95703 4.95703 2.5 8 2.5ZM8 5.5C8.83594 5.5 9.5 6.16406 9.5 7C9.5 7.83594 8.83594 8.5 8 8.5C7.16406 8.5 6.5 7.83594 6.5 7C6.5 6.16406 7.16406 5.5 8 5.5ZM8 9.5C9.69922 9.5 11.0938 10.707 11.418 12.3086C10.4766 13.0547 9.29297 13.5 8 13.5C6.70703 13.5 5.52344 13.0547 4.58594 12.3086C4.90625 10.707 6.30078 9.5 8 9.5Z" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
  </svg>;
const OrganizationIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => <svg fill="currentcolor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="OrganizationIcon" data-sentry-source-file="authkit-diagrams.tsx">
    <path d="M6 1C5.45312 1 5 1.45312 5 2V5C5 5.54688 5.45312 6 6 6H6.04297L3.04297 9H2C1.45312 9 1 9.45312 1 10V13C1 13.5469 1.45312 14 2 14H5C5.54688 14 6 13.5469 6 13V10C6 9.45312 5.54688 9 5 9H4.45703L7.45703 6H7.54297L10.543 9H10C9.45312 9 9 9.45312 9 10V13C9 13.5469 9.45312 14 10 14H13C13.5469 14 14 13.5469 14 13V10C14 9.45312 13.5469 9 13 9H11.957L8.95703 6H9C9.54688 6 10 5.54688 10 5V2C10 1.45312 9.54688 1 9 1H6ZM6 2H9V5H6V2ZM2 10H5V13H2V10ZM10 10H13V13H10V10Z" data-sentry-element="path" data-sentry-source-file="authkit-diagrams.tsx" />
  </svg>;
export const UserManagementDiagrams = {
  AuthenticationMethods,
  EnterpriseUsers,
  IdentityLinking,
  UserToOrganizationRelationships
};